import { Button, Grid2 as Grid, Grid2Props, IconButton } from "@mui/material";
import React from "react";
import { useFormHandlerContext } from "../../controllers/formController";
import { singleGridItem } from "../../components/forms/fields/defaultStyles";
import ArraySubFormProvider from "../../components/forms/fields/subForms/array/ArraySubFormProvider";
import ArraySubFormList from "../../components/forms/fields/subForms/array/ArraySubFormList";
import FormLabel from "../../components/forms/common/base/FormLabel";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import GroupGridContainer from "../../components/common/GroupGridContainer";
import ArraySubFormAdd from "../../components/forms/fields/subForms/array/ArraySubFormAdd";
import PersonNameInternalEvidence from "./PersonNameInternalEvidence";
import usePersonLogic from "../../hooks/logic/personLogic";

interface PersonNameInternalEvidenceListProps extends Grid2Props {
  name: string;
  label: string;
  rowLabel: string;
  disabled?: boolean;
  placeHolder?: string | ((index: number) => string);
}

const PersonNameInternalEvidenceList: React.FC<
  PersonNameInternalEvidenceListProps
> = ({ name, label, rowLabel, placeHolder, disabled = false, ...grid }) => {
  const { isProcessing } = useFormHandlerContext();
  const { defaultPersonNameInternalEvidence } = usePersonLogic();
  return (
    <Grid container spacing={1} {...singleGridItem} {...grid}>
      <FormLabel label={label} name={name} />
      <ArraySubFormProvider name={name}>
        <ArraySubFormList
          renderItem={(index, remove) => (
            <GroupGridContainer key={index}>
              <Grid {...singleGridItem}>
                <FormLabel
                  sx={{ fontSize: "1.2rem" }}
                  label={`${rowLabel} ${index + 1}`}
                  actions={
                    <IconButton
                      color="error"
                      onClick={() => remove()}
                      size="small"
                      disabled={disabled || isProcessing}
                    >
                      <RemoveCircleOutline />
                    </IconButton>
                  }
                />
              </Grid>
              <Grid {...singleGridItem}>
                <PersonNameInternalEvidence />
              </Grid>
            </GroupGridContainer>
          )}
        />

        <Grid {...singleGridItem}>
          <ArraySubFormAdd
            render={(append) => (
              <Button
                variant="contained"
                fullWidth
                color="primary"
                startIcon={<AddCircleOutline />}
                disabled={disabled || isProcessing}
                onClick={() => append(defaultPersonNameInternalEvidence)}
              >
                Add {rowLabel}
              </Button>
            )}
          />
        </Grid>
      </ArraySubFormProvider>
    </Grid>
  );
};

export default PersonNameInternalEvidenceList;
